import React from 'react';

/**
 * A small pill for a claim or report row with unresolved questions: amber
 * while any is waiting on an answer, blue once they are all answered and
 * waiting on the asker to resolve them. Renders nothing when there are none.
 *
 * @param {Array}    threads  the item's unresolved threads
 * @param {Function} [onClick] open them
 */
const QuestionBadge = ({ threads = [], onClick, className = '' }) => {
  if (!threads.length) return null;
  const waiting = threads.filter(t => t.status === 'open').length;
  const tone = waiting > 0 ? 'bg-amber-100 text-amber-800' : 'bg-blue-100 text-blue-800';
  const label = `${threads.length} question${threads.length === 1 ? '' : 's'}`;
  const title = waiting > 0
    ? `${waiting} awaiting an answer${threads.length > waiting ? `, ${threads.length - waiting} answered` : ''}`
    : 'Answered - waiting for the asker to resolve';
  const classes = `inline-flex items-center gap-1 px-2 py-0.5 text-xs font-semibold rounded-full ${tone} ${className}`;

  if (onClick) {
    // Rows that open their claim on click hold this badge, so the click
    // stops here rather than also opening the claim.
    return (
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); onClick(e); }}
        title={title}
        className={`${classes} hover:opacity-80`}
      >
        <span aria-hidden="true">?</span> {label}
      </button>
    );
  }
  return (
    <span title={title} className={classes}>
      <span aria-hidden="true">?</span> {label}
    </span>
  );
};

export default QuestionBadge;
